import React from 'react';

function FlowTableHeader() {
	return (
		<thead className="bg-gray-50 border-b border-gray-200">
			<tr>
				<th
					scope="col"
					className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider w-16"
				>
					Id
				</th>
				<th
					scope="col"
					className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
				>
					Name
				</th>
				<th
					scope="col"
					className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider w-20"
				>
					Active
				</th>
				<th
					scope="col"
					className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider w-24"
				>
					Favorite
				</th>
				<th
					scope="col"
					className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider w-28"
				>
					Voice
				</th>
				<th
					scope="col"
					className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider w-32"
				>
					Action
				</th>
			</tr>
		</thead>
	);
}

export default FlowTableHeader;
